import _ from 'lodash';
import { get as getProperties } from './propertiesLogic';
export var isMultiLocationSite = function (organization) {
    return _.get(getProperties(organization, 'wixrestaurants', 'com.wix.restaurants'), 'isMultiLocationEnabled', false);
};
//# sourceMappingURL=multilocationLogic.js.map